import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PolicyService } from '@services/policy.service';
import Swal from 'sweetalert2'
import { CoreModule } from 'app/modules/core.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { NumberPipe } from 'app/pipes/number.pipe';
import { CollectionComponent } from '@components/managements/collection/collection.component';
import { CampusService } from '@services/campus.service';

@Component({
  selector: 'app-modal-policy',
  standalone: true,
  imports: [CoreModule, NgSelectModule, CommonModule, NumberPipe, CollectionComponent],
  providers: [PolicyService, CampusService],
  templateUrl: './modal-policy.component.html',
  styleUrls: ['./modal-policy.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalPolicyComponent implements OnInit {

  @Input() policy: any
  @Input() year: any
  @Input() permissions: any

  @Output() refresh = new EventEmitter<Boolean>()

  private _policyService = inject(PolicyService)
  private _officeService = inject(CampusService)


  protected listOffices = []
  protected listCoverages = []
  protected saveData: boolean = false









  public PolicyForm: FormGroup
  public coverageForm: FormGroup
  public newPolicy = true
  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })

  updateCollection = false

  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
  ) {
    this.PolicyForm = this.fb.group({
      _id: [null],
      coverageId: [null, Validators.required],
      entityId: [null],
      name: [null],
      code: [null],
      rut: [null],
      dv: [null],
      year: [null, [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      startDate: [null, [Validators.required]],
      
      coverage: this.fb.group({
        allowsDependents: [false],
        allowUpgrade: [false],
        missionary: [false],
        enabled: [true],
      })
    })


  }

  ngOnInit(): void {
    if (this.policy != null) {
      this.newPolicy = false
      this.PolicyForm.patchValue({
        _id: this.policy._id,
        entityId: this.policy.entityId,
        name: this.policy.entity.name,
        code: this.policy.code,
        rut: this.policy.entity.rut,
        dv: this.policy.entity.dv,
        year: this.policy.year,
        coverageId: this.policy.coverageId,
        startDate: this.policy.startDate.split("T")[0],
        coverage: this.policy.coverage
      })

      this.getCoverage()

    }
    this.getEntities()
    this.getCoverages()
  }

  submit() {
    if (this.PolicyForm.valid) {
      this.newPolicy == true ? this._policyService.save(this.PolicyForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { this.cerrarModal(res) }) : this._policyService.update(this.PolicyForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { this.cerrarModal(res); this.newPolicy = true; this.cdr.markForCheck() })
      this.Toast.fire({
        text: 'Póliza actualizada',
        icon: 'success'
      })
      this.cancel()
    }
  }

  updateCoveragePolicy(){
    
  }

  getEntities() {
    this._officeService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listOffices = res
      this.cdr.markForCheck()
    })
  }

  getCoverages() {
    this._policyService.getCoverages().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listCoverages = res
      this.cdr.markForCheck()
    })
  }

  getCoverage() {
    // this._policyService.getCoverages(this.PolicyForm.value.coverageId).subscribe(res => {
    //   this.PolicyForm.get('coverage')?.patchValue(res)
    // })

  }

  setOffice(office: any) {
    this.PolicyForm.patchValue({
      entity: office._id,
      rut: office.rut,
      dv: office.dv
    })
  }


  changeStatus() {
    this.PolicyForm.get('coverage')?.patchValue({enabled: !this.PolicyForm.get('coverage')?.enabled})
  }

  cerrarModal(res: any) {
    if (res) this.refresh.emit(true)
    this.PolicyForm.reset()
  }

  cancel() {
    this.refresh.emit(false)
    this.PolicyForm.reset()
  }
}
